module.exports = __webpack_public_path__ + "media/styles/images/svg/eraser-teal-dd0b39c1a7806fba88ad0953b0e5b503.svg";